import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '24px 0 0 0',
    maxWidth: 'calc(100% / 3)',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start'
    }

  },
  texts: {
    marginLeft: '18px',

    '& .MuiTypography-overline': {
      color: theme.palette.gray.midGray,
      fontWeight: 700,
      fontSize: 12
    },

    '& .MuiTypography-subtitle1': {
      color: theme.palette.gray.darkGray,
      letterSpacing: 0,
    }
  },
  maxWidth: {
    // maxWidth: 'calc(100% / 3)'
  }
}))

export default function IconTitleDescription({ information }) {
  const classes = useStyles();

  const { icon, title, description } = information;

  return (
    <>
    {description.length < 1
      ? (
        <Box className={classes.wrapper}>
          <Box className={classes.image}>
            {''}
          </Box>
          <Box className={classes.texts} >
            <Typography variant={'overline'}>
              {''}
            </Typography>
            <Typography variant={'subtitle1'}>
              {''}
            </Typography>
          </Box>
      </Box>
        )
      : (
    <Box className={classes.wrapper}>
      <Box className={classes.image}>
        {icon}
      </Box>
      <Box className={classes.texts} >
        <Typography variant={'overline'} component="p">
          {title}
        </Typography>
        <Typography variant={'subtitle1'} component="span" className={title === 'ALÍQUOTA' ? classes.maxWidth : ''}>
          {description}
        </Typography>
      </Box>
    </Box>
        )}
    </>
  )
}

IconTitleDescription.propTypes = {
  information: PropTypes.object.isRequired
}
